import { type TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux"
import configureStore from "./configureStore"

export const store = configureStore()

export type AppStore = typeof store
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppStore: () => AppStore = useStore

export default store
